/** `/workspace/:id/room/:roomId` — a Design Room inside the app shell (members). Guests use `/r/:token`. */
import { createFileRoute, Link } from '@tanstack/react-router'
import { AppHeader } from '#/components/layout/app-header'
import { RoomView } from '#/components/room/room-view'
import { ApiError, useWorkspacePlans } from '#/lib/api'
import { useRoom } from '#/lib/api-room'
import { m } from '#/paraglide/messages'

export const Route = createFileRoute('/workspace/$workspaceId/room/$roomId')({
  head: () => ({ meta: [{ title: m.rm_name() }] }),
  component: RoomPage,
})

function RoomPage() {
  const { workspaceId, roomId } = Route.useParams()
  const { data: ws } = useWorkspacePlans(workspaceId)
  const { data, error, live } = useRoom(roomId)
  return (
    <>
      <AppHeader
        showStats={false}
        compact
        left={
          <nav className="hidden items-center gap-1 truncate text-sm text-muted-foreground lg:flex">
            <span>/</span>
            <Link to="/workspace/$workspaceId" params={{ workspaceId }} className="truncate hover:text-foreground">{ws?.workspace.name ?? '…'}</Link>
            <span>/</span>
            <Link to="/workspace/$workspaceId/room" params={{ workspaceId }} className="truncate hover:text-foreground">{m.rm_index_title()}</Link>
            <span>/</span>
            <span className="truncate text-foreground">{data?.room.title ?? '…'}</span>
          </nav>
        }
      />
      <main className="min-h-0 flex-1 overflow-y-auto">
        {error ? (
          <p className="p-8 text-sm text-destructive">{error instanceof ApiError ? error.message : m.rm_err_generic()}</p>
        ) : data ? (
          <RoomView snap={data} live={live} shell="app" />
        ) : (
          <p className="p-8 text-sm text-muted-foreground">{m.st_loading()}</p>
        )}
      </main>
    </>
  )
}
